import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from './Badge';
import { FiFile } from 'react-icons/fi';
import {
  formatDateTimeInTzWithLocale,
} from '@utils/dateWithTz.tsx';

interface ComponentProps {
  updatedAt: string;
  updatedBy: string;
  updatedEmail: string;
  timezoneId: string;
  dataTestId?: string;
}

const UpdatedBadge: React.FC<ComponentProps> = ({ updatedAt, updatedBy, updatedEmail, timezoneId, dataTestId }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      <a href={`mailto:${updatedEmail}`}>
        <Badge
          text={tr('UpdatedBadge.updatesWithTz', '{{fullName}} ({{-dateWithTimeDash}})', {
            fullName: updatedBy,
            dateWithTimeDash: formatDateTimeInTzWithLocale(updatedAt, timezoneId),
          })}
          icon={<FiFile />}
          dataTestId={dataTestId}
        />
      </a>
    </>
  );
};

export default UpdatedBadge;
